const getTenantRecipientUrl = (recipientId: string | undefined): string => {
  return `https://dash.pagar.me/merch_4PxlzxbsOhbD02on/acc_qo8Nm36cLh4G71rx/${recipientId}/recipient-details`
}

const TenantFunctions = {
  getTenantRecipientUrl,
}

export default TenantFunctions
